import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { RootState } from '../../../app/store';


interface BoardStateClass {
    isLoading: boolean
    status: 'idle' | 'loading' | 'failed';
    isSummaryLoading: boolean;
}

interface IThunkApi {
    state: {
        board: BoardStateClass;
    },
}

const initialState: BoardStateClass = {
    isLoading: true,
    status: 'idle',
    isSummaryLoading: false
}


export const GetAccountStatus = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Projects/GetAccountStatus',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/Status`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const GetAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/GetAccountProjectTask',
        async (arg, thunkApi) => {
            const { AccountProjectId } = arg
            const response = await fetchTimeliveAPI(`api/Task/GetAccountProjectTask/${AccountProjectId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const GetAccountProjectTaskTeam = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/GetAccountProjectTaskTeam',
        async (arg, thunkApi) => {
            const { AccountProjectId, taskId } = arg
            const response = await fetchTimeliveAPI(`api/Task/GetAccountProjectTaskTeam/${AccountProjectId}/${taskId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const UpdateAccountProjectTaskField = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/UpdateAccountProjectTaskField',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/Task/UpdateAccountProjectTaskField/${arg?.AccountProjectTaskId}`, `PUT`, arg, true);
            const json = await response.json();
            return json;
        }
    )

export const AddOrRemoveAccountProjectTaskTeam = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/AddOrRemoveAccountProjectTaskTeam',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/Task/AddOrRemoveAccountProjectTaskTeam`, `POST`, arg, true);
            const json = await response.json();
            return json;
        }
    )

export const AddTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/AddTask',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/Task`, `POST`, arg, true);
            const json = await response.json();
            return json;
        }
    )

export const DeleteTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Projects/DeleteTask',
        async (arg, thunkApi) => {
            const { AccountProjectId, AccountProjectTaskId } = arg;
            const response = await fetchTimeliveAPI(`api/Task/${AccountProjectId}/${AccountProjectTaskId}`, `DELETE`, arg, true);
            const json = await response.json();
            return json;
        }
    )
export const updateEmployeeShowAdvanceBoardAction = createAsyncThunk<any, any, IThunkApi>(
    'Employee/UpdateEmployeeShowAdvanceBoard',
    async (arg, thunkApi) => {
        try {
            const response = await fetchTimeliveAPI(`api/Employee/UpdateEmployeeShowAdvanceBoard`, 'PUT',arg, true);
            const json = await response.json();
            return json;
        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }    
);

export const boardSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        updateIsSummaryLoading: (state, action: PayloadAction<boolean>) => {
            state.isSummaryLoading = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAccountStatus.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountStatus.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(GetAccountStatus.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountProjectTask.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountProjectTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(GetAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountProjectTaskTeam.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountProjectTaskTeam.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(GetAccountProjectTaskTeam.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(UpdateAccountProjectTaskField.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateAccountProjectTaskField.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(UpdateAccountProjectTaskField.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(AddOrRemoveAccountProjectTaskTeam.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(AddOrRemoveAccountProjectTaskTeam.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(AddOrRemoveAccountProjectTaskTeam.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(AddTask.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(AddTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(AddTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(DeleteTask.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(DeleteTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const { updateIsSummaryLoading } = boardSlice.actions;
export const BoardState = (state: RootState) => state.board;
export default boardSlice.reducer